import React from 'react'
import classNames from 'classnames'
import type { LinkProps } from 'react-router'
import { Link } from 'react-router'

import type { BaseButtonProps } from './BaseButton'
import { BaseButton, BaseButtonContent } from './BaseButton'

export type ButtonLinkProps = LinkProps & Omit<BaseButtonProps, 'children'>

export const ButtonLink = ({
  variant,
  size,
  icon,
  children,
  disabled,
  className: _className,
  isActive,
  iconPosition,
  iconSize,
  iconClassName,
  transparent,
  align,
  ...props
}: ButtonLinkProps) => {
  const isBlankTarget = !!props.target && props.target === '_blank'

  return (
    <BaseButton
      variant={variant}
      size={size}
      disabled={disabled}
      isActive={isActive}
      transparent={transparent}
      align={align}
    >
      {(outerClassName, outerStyle, innerClassName, innerStyle) => (
        <Link
          {...props}
          onClick={(e) => {
            if (disabled) {
              e.preventDefault()
            }
            props?.onClick?.(e)
          }}
          style={{ ...props.style, ...outerStyle }}
          className={classNames(outerClassName, _className)}
          rel={isBlankTarget ? 'noopener noreferrer' : undefined}
        >
          <div className={innerClassName} style={innerStyle}>
            <BaseButtonContent
              icon={icon}
              content={children}
              size={size}
              iconClassName={iconClassName}
              iconPosition={iconPosition}
              iconSize={iconSize}
            />
          </div>
        </Link>
      )}
    </BaseButton>
  )
}
